function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * @Author: Wolf.Ma
 * @Date: 2023-09-04 14:35:45
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-09-25 15:55:40
 * @FilePath: /njoy-design/src/njoyTextArea/index.tsx
 * @Description:
 */
import { ConfigProvider, Input } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { antdTheme, njoydTheme } from "../theme";
import "./styles/index.less";
var isComposition = false;
var NjTextArea = function NjTextArea(props) {
  // console.log('props', props);
  // antd 原生主题对象
  var antd = antdTheme();
  // njoyd 原生主题对象
  var njoyd = njoydTheme();
  var value = props.value,
    style = props.style,
    _props$allowClear = props.allowClear,
    allowClear = _props$allowClear === void 0 ? false : _props$allowClear,
    _props$showCount = props.showCount,
    showCount = _props$showCount === void 0 ? false : _props$showCount,
    _props$maxLength = props.maxLength,
    maxLength = _props$maxLength === void 0 ? 999999999 : _props$maxLength,
    maxlengthtips = props.maxlengthtips,
    _props$iscanpull = props.iscanpull,
    iscanpull = _props$iscanpull === void 0 ? true : _props$iscanpull,
    _props$chinesebyte = props.chinesebyte,
    chinesebyte = _props$chinesebyte === void 0 ? 1 : _props$chinesebyte,
    _props$numberbyte = props.numberbyte,
    numberbyte = _props$numberbyte === void 0 ? 1 : _props$numberbyte,
    _props$otherbyte = props.otherbyte,
    otherbyte = _props$otherbyte === void 0 ? 1 : _props$otherbyte,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    valueLength = _useState2[0],
    setValueLength = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    valueS = _useState4[0],
    setValues = _useState4[1];
  var textareaRef = useRef(null);
  useEffect(function () {
    if (value) {
      initValue(value);
    } else {
      setValueLength(0);
      setValues(undefined);
    }
  }, [value]);
  var initValue = function initValue(value) {
    computeLength(value);
    onPressEnter();
  };

  /**
   * 修改
   */
  var handleChange = function handleChange(e) {
    var inputValue = e.target.value;
    setValues(inputValue);
    if (!isComposition) {
      computeLength(inputValue);
    }
  };
  /**
   * 计算长度
   */
  var computeLength = function computeLength(value) {
    var sum = 0;
    var tempStr = '';
    for (var _key in value) {
      if (value[_key].replace(/[^\d]/g, '')) {
        // 数据只留下数字 计算长度
        sum += numberbyte;
      } else if (value[_key].replace(/[^\u4e00-\u9fa5]/g, '')) {
        // 数据只留下汉字 计算长度
        sum += chinesebyte;
      } else {
        // 计算一下 其他的长度
        sum += otherbyte;
      }
      tempStr += value[_key];
      // 有长度限制
      if (maxLength && sum >= maxLength) {
        setValueLength(sum);
        setValues(tempStr);
        onChange(tempStr);
        return;
      }
    }
    setValueLength(sum);
    setValues(tempStr);
    onChange(tempStr);
  };

  /**
   * 清空
   */
  var clearAll = function clearAll() {
    setValues('');
    setValueLength(0);
    onChange('');
  };

  /**
   * 点击回车键
   */
  var onPressEnter = function onPressEnter() {
    var _textareaRef$current;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var textarea = (_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 ? void 0 : _textareaRef$current.resizableTextArea.textArea;
    textarea.scrollTop = textarea.scrollHeight + 30;
  };

  /**
   * 监控
   * @param e
   */
  var handleComposition = function handleComposition(e) {
    if (e.type === 'compositionend') {
      isComposition = false;
      initValue(valueS);
    } else {
      isComposition = true;
    }
  };
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      token: antd
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "njoy-text-area"
  }, /*#__PURE__*/React.createElement(Input.TextArea, _extends({
    ref: textareaRef,
    onPressEnter: onPressEnter
  }, props, {
    allowClear: false,
    showCount: false,
    value: valueS,
    style: _objectSpread(_objectSpread({}, style), {}, {
      borderRadius: njoyd.borderRadius || antd.borderRadius,
      paddingBottom: '30px',
      resize: iscanpull ? 'block' : 'none'
    }),
    onCompositionStart: handleComposition,
    onCompositionEnd: handleComposition,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "bottom-button"
  }, showCount && /*#__PURE__*/React.createElement("div", {
    className: "count",
    style: {
      color: maxlengthtips && valueLength >= maxLength ? 'red' : ''
    }
  }, valueLength, maxLength && " / ".concat(maxLength)), allowClear && /*#__PURE__*/React.createElement("div", {
    className: classNames('clear', {
      can: valueLength > 0
    }),
    style: {
      color: valueLength ? njoyd.colorPrimary || antd.colorPrimary : ''
    },
    onClick: function onClick() {
      return clearAll();
    }
  }, "\u6E05\u7A7A"))));
};
export default NjTextArea;